export default __webpack_public_path__ + "homepageComputer_integrate.png";